// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DMNB","select":"styles_select__3W5ZY"};